<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-6">
                <div class="search-box mr-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input type="text" class="form-control" v-model="search" placeholder="Digite e pressione 'ENTER'" @keyup.enter="doSearch"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="float-sm-end d-flex">
                  <div class="text-sm-right" v-if="user.role === 'Admin' && (!controls || controls.length === 0)">
                    <button type="button" class="btn btn-success btn-rounded mb-2 mr-2" @click="newControl()">
                      <i class="mdi mdi-plus mr-1"></i> Novo Controle
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-centered table-nowrap table-hover">
                <thead>
                  <tr>
                    <th width="30%">Nome</th>
                    <th width="20%">Label Identificador</th>
                    <th width="15%">Modo de Vagas</th>
                    <th width="10%">Itens</th>
                    <th width="10%">Status</th>
                    <th>#</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in controls" :key="item.id">
                    <td class="link" @click="goToItems(item)">
                      <span class="badge font-size-14 badge-soft-primary" style="min-width:100px">{{ item.name }}</span>
                    </td>
                    <td class="link" @click="goToItems(item)">
                      {{ item.identifier_label }}
                    </td>
                    <td class="link" @click="goToItems(item)">
                      <span class="badge font-size-12" :class="{'badge-soft-info': item.vacancy_mode === 'per_item', 'badge-soft-warning': item.vacancy_mode === 'per_group', 'badge-soft-primary': item.vacancy_mode === 'per_item_and_group'}">
                        {{ item.vacancy_mode === 'per_item' ? 'Individual' : (item.vacancy_mode === 'per_group' ? 'Em grupo' : 'Individual + Grupo') }}
                      </span>
                    </td>
                    <td class="link" @click="goToItems(item)">
                      {{ item.items_count }}
                    </td>
                    <td class="link" @click="goToItems(item)">
                      <span class="badge font-size-12" :class="{'badge-soft-success': item.active, 'badge-soft-danger': !item.active}">
                        {{ item.active ? 'Ativo' : 'Inativo' }}
                      </span>
                    </td>
                    <td>
                      <button v-if="user.role === 'Admin'" type="button" @click="editControl(item)" class="link btn btn-outline-primary btn-sm mr-1">
                        <i class="bx bx-edit"></i>
                      </button>
                      <button v-if="user.role === 'Admin'" type="button" @click="deleteControl(item)" class="link btn btn-outline-danger btn-sm">
                        <i class="bx bx-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @input="updateList"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-form v-model="modalForm" :controlData="selectedControl" ref="formControl" @created="updateList"></modal-form>
  </Layout>
</template>
<script>
import Swal from 'sweetalert2'
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import ModalForm from './Form'
import appConfig from '@/app.config'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    Layout,
    PageHeader,
    ModalForm
  },
  name: 'RegistrationControls',
  page: {
    title: 'Controle de Inscrição',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      loading: true,
      search: '',
      modalForm: false,
      params: {},
      currentPage: 1,
      perPage: 20,
      selectedControl: null,
      title: 'Controle de Inscrição',
      items: [{
        text: 'Controle de Inscrição'
      },
      {
        text: 'Listagem',
        active: true
      }]
    }
  },
  mounted () {
    this.updateList()
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('registrationControl', ['controls', 'pagination']),
    rows () {
      return this.pagination.total
    }
  },
  methods: {
    ...mapActions('registrationControl', {
      getAll: 'getAll',
      deleteAction: 'remove'
    }),
    newControl () {
      this.selectedControl = null
      this.$refs.formControl.open(null)
      this.modalForm = true
    },
    editControl (control) {
      if (this.user.role === 'Admin') {
        this.selectedControl = control
        this.$refs.formControl.open(control)
        this.modalForm = true
      }
    },
    goToItems (control) {
      this.$router.push({ name: 'registration-control-items', params: { controlId: control.id } })
    },
    deleteControl (control) {
      Swal.fire({
        title: 'Você tem certeza ?',
        html: `Será excluído o controle: <b>${control.name}</b>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, DESEJO EXCLUIR!'
      }).then(result => {
        if (result.value) {
          try {
            this.deleteAction(control.id)
            successMessage('Sucesso: Controle excluído com sucesso.', 2500)
            this.updateList()
          } catch (err) {
            errorMessage('Alerta: ' + err.response.data.message)
          }
        }
      })
    },
    getReport () {
      let params = {
        search: this.search || null,
        limit: this.perPage,
        page: this.currentPage
      }
      this.params = params
      let loader = this.$loading.show()
      this.getAll(this.params).then(() => {
        loader.hide()
      }).catch(error => {
        console.log(error)
        loader.hide()
      })
    },
    doSearch () {
      this.params = { ...this.params, search: this.search }
      this.getReport()
    },
    updateList () {
      this.getReport()
    }
  }
}
</script>
<style scoped>
.link { cursor: pointer; }
.swal2-popup {
  font-size: 11px !important;
}
.table-responsive { min-height: 300px; }
.float-sm-end { float: right; }
</style>
